var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 952,
    viewBox: "0 0 1920 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_b_1915_34003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-131 445.672C-93.6667 392.839 10.9 288.572 130.5 294.172C280 301.172 545 699.672 719.5 682.172C859.1 668.172 925.218 565.465 968.5 522.999C995 496.999 1064.2 413.599 1105 397.999C1156 378.499 1211 395.499 1239.5 411.499C1268 427.499 1352.5 514.172 1391.5 542.672C1430.5 571.172 1461.5 553.172 1497.5 514.672C1533.5 476.172 1797.5 -68.3276 1985 7.17241C2135 67.5724 2088.17 532.339 2046 757.173C2004.33 810.173 1872.7 912.073 1679.5 895.673C1438 875.173 1255.5 602.173 1130 632.173C1004.5 662.173 950.5 769.999 884.5 776.499C818.5 782.999 713.5 716.673 670.5 696.673C627.5 676.673 566 626.673 479 614.673C409.4 605.073 319.667 642.006 283.5 661.673C211.5 698.673 54.2 796.273 1 890.673C-52.2 985.073 -96.5 949.673 -112 920.173L-131 445.672Z",
    fill: "#F0F7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1915_34003",
    x: -146,
    y: -15.001,
    width: 2248.66,
    height: 981.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1915_34003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1915_34003",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBg);
export default __webpack_public_path__ + "static/media/servicesBg.f0a92a6eed79d1ddfe78dc54320b2d8a.svg";
export { ForwardRef as ReactComponent };